(ns frontend.ui.component.lp-portal.report.body.real-estate.fund.hotel.web.view
  (:require
   [frontend.ui.component.grid.view :as grid]
   [frontend.ui.component.lp-portal.card.view :refer [card]]
   [frontend.ui.component.lp-portal.report.esg.key-perf-indicators.view :as esg-kpi]
   [frontend.ui.component.lp-portal.report.overview.big-figures.view
    :refer [overview-figures-card]]
   [frontend.ui.component.lp-portal.report.tearsheet.portfolio-locations.view
    :refer [portfolio-locations-card]]
   [frontend.ui.component.lp-portal.report.tearsheet.return-development.view
    :refer [return-development-card]]
   [frontend.ui.component.lp-portal.report.tearsheet.basic-information.view
    :refer [basic-information-card]]
   [frontend.ui.component.lp-portal.section.view :refer [section]]
   [frontend.ui.component.lp-portal.report.overview.recent-development-figures.view :as recent-dev]
   [frontend.ui.component.lp-portal.report.module.chart-card :as chart-card]
   [frontend.ui.component.lp-portal.report.module.tabular-card :as tabular-card]
   [frontend.ui.component.lp-portal.report.module.free-text-card :as free-text-card]
   [frontend.ui.component.lp-portal.card.view :as card]
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.common.view :as re]
   [frontend.ui.component.lp-portal.report.tearsheet.largest-investments-at-fair-value.view :as
    largest-investments]))

(defn tearsheet-section
  [{:keys [largest-investment-by-nav portfolio-locations]
    :as   tearsheet} props]
  [section
   "Tear sheet"
   (str "tearsheet-"
        (some->> props
                 :report
                 :db/id))
   [:div
    [grid/row {}
     [grid/column {:large 6}
      [return-development-card tearsheet props]]
     [grid/column {:large 6}
      [largest-investments/largest-investments-by-NAV largest-investment-by-nav props]
      [portfolio-locations-card portfolio-locations props]]]
    [basic-information-card tearsheet props]]])

(defn overview-section
  [{:keys [overview-figures
           recent-development
           recent-development-text
           net-development
           fund-nav-change-breakdown
           total-return
           portfolio-at-market-value
           gav-breakdown
           market-value-by-location
           market-value-by-currency]
    :as   overview} props]
  [section
   "Overview"
   (str "overview-"
        (some->> props
                 :report
                 :db/id))
   [:div
    [overview-figures-card overview-figures props]
    [recent-dev/recent-development-with-highlights-card recent-development-text recent-development
     (assoc props :title "Fund Figures (INREV)")]
    [grid/row {}
     [grid/column {:span 6}
      [chart-card/view "NAV Development" net-development props]]
     [grid/column {:span 6}
      [chart-card/view "Fund NAV Change Breakdown" fund-nav-change-breakdown props]]]
    [tabular-card/dynamic-table "Total return on a time weighted basis" total-return props]
    [grid/row {}
     [grid/column {:span 6}
      [chart-card/view "Market value by operator, M€" portfolio-at-market-value props]]
     [grid/column {:span 6}
      [chart-card/view "GAV breakdown, M€" gav-breakdown props]]]
    [grid/row {}
     [grid/column {:span 6}
      [chart-card/view "Market value by location, M€" market-value-by-location props]]
     [grid/column {:span 6}
      [chart-card/view "Market value by currency, M€" market-value-by-currency props]]]]])

(defn debt-financing-section
  [{:keys [debt-financing-text
           debt-key-figures
           portfolio-debt-financing 
           lender-by-loan-commitment
           lender-by-loans-outstanding ]}
   props]
  [section
   "Debt financing"
   (str "debt-financing-"
        (some->> props
                 :report
                 :db/id))
   [:div
    [grid/row {}
     [grid/column {:large 6}
      [free-text-card/view "Description" debt-financing-text props]]
     [grid/column {:large 6}
      [tabular-card/dynamic-table "Portfolio Debt key figures" debt-key-figures props]]]
    [:div
     [tabular-card/dynamic-table "Debt Financing, €" portfolio-debt-financing props]]
    [grid/row {}
     [grid/column {:large 6}
      [chart-card/view "Lender by loan commitment, M€" lender-by-loan-commitment props]]
     [grid/column {:large 6}
      [chart-card/view "Lender by loans outstanding, M€" lender-by-loans-outstanding props]]]]])

(defn details-and-figures-section
  [{:keys [current-portfolio
           investment-summary
           exited-portfolio
           nav-breakdown
           inrev-nav]}
   props]
  [section
   "Details and figures"
   (str "details-and-figures-"
        (some->> props
                 :report
                 :db/id))
   [:div
    [tabular-card/dynamic-table "Current portfolio, €" current-portfolio props]
    [tabular-card/dynamic-table "Exited portfolio, €" exited-portfolio props]
    [tabular-card/dynamic-table "Investment summary, €" investment-summary props]
    [tabular-card/dynamic-table "NAV breakdown, €" nav-breakdown props]
    [tabular-card/dynamic-table "NAV breakdown (INREV), €" inrev-nav props]]])

(defn financial-statements-section
  [{:keys [group-income-statement
           statement-of-financial-position
           cash-flow-statement]}
   props]
  [section
   "Financial statements"
   (str "financial-statements-"
        (some->> props
                 :report
                 :db/id))
   [:div
    [tabular-card/dynamic-table "Consolidated statement of comprehensive income (INREV), €"
     group-income-statement props]
    [tabular-card/dynamic-table "Consolidated statement of financial position (INREV), €"
     statement-of-financial-position props]
    [tabular-card/dynamic-table "Consolidated statement of cash flows (INREV), €"
     cash-flow-statement props]]])

(defn hotel
  [{:keys [fund-ui-data] :as props}]
  (let [{:keys [tearsheet overview debt-financing esg details-and-figures financial-statements]}
        fund-ui-data]
    [:div
     ^{:key :tearsheet}
     [tearsheet-section tearsheet props]
     ^{:key :overview}
     [overview-section overview props]
     ^{:key :debt-financing}
     [debt-financing-section debt-financing props]
     ^{:key :esg}
     [re/esg-section esg props]
     ^{:key :details-and-figures}
     [details-and-figures-section details-and-figures props]
     ^{:key :group-income-statement}
     [financial-statements-section financial-statements props]]))
